<script setup>
import AppRoute from 'src/router/app-route';
import { Route } from 'src/router/routes';
import { useAuthStore } from 'stores/auth-store';
import { computed } from 'vue';

const authStore = useAuthStore();

const accountMarketRoute = computed(() => {
    return AppRoute.build(authStore.userAuthenticated ? Route.Dashboard : Route.Login);
});

const accountMarketLabel = computed(() => {
    return authStore.userAuthenticated ? 'Open My Market' : 'Save one market';
});
</script>

<template>
    <section aria-labelledby="account-value-heading" class="account-value-section">
        <div class="account-value-grid">
            <div class="account-value-copy">
                <p class="font-mono text-caption text-uppercase text-hint q-mb-xs">An account is optional</p>
                <h2 id="account-value-heading" class="text-h4 text-weight-bold q-mt-none q-mb-sm">Keep one market close.</h2>
                <p class="text-body1 q-mt-none q-mb-lg">
                    Everything on the public pages is free to read without logging in. An account adds a place to return
                    to, and nothing you do not ask for.
                </p>
                <q-btn
                    :label="accountMarketLabel"
                    :to="accountMarketRoute"
                    color="white"
                    data-test="account-market-link"
                    icon-right="sym_r_arrow_forward"
                    no-caps
                    text-color="primary"
                    unelevated
                />
            </div>
            <div class="account-benefits">
                <article class="cta-card q-pa-lg">
                    <h3 class="text-h6 text-weight-bold q-mt-none q-mb-xs">Save one market</h3>
                    <p class="text-body2 text-hint q-mb-none">
                        Pick one ICT specialisation and one Australian location. My Market shows its current snapshot
                        every time you come back.
                    </p>
                </article>
                <article class="cta-card q-pa-lg">
                    <h3 class="text-h6 text-weight-bold q-mt-none q-mb-xs">Reuse basic details selectively</h3>
                    <p class="text-body2 text-hint q-mb-none">
                        Shared basic details may prefill an application, and only for roles that accept applications
                        through Xprt Jobs.
                    </p>
                </article>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.account-value-section {
    .account-value-grid {
        display: grid;
        gap: 48px;
        grid-template-columns: minmax(0, 1fr) minmax(320px, 1fr);
    }

    .account-value-copy {
        max-width: 420px;
    }

    .account-benefits {
        display: grid;
        gap: 16px;
    }

    @media (max-width: $breakpoint-sm-max) {
        .account-value-grid {
            gap: 32px;
            grid-template-columns: 1fr;
        }
    }
}
</style>
